export default {"src":"/_next/static/media/img-blog-mask-black.4a6f75f7.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};